import { NavigationActions } from "@react-navigation/core";
var initAction = NavigationActions.init();

function createNavigationReducer(navigator) {
  var initialState = navigator.router.getStateForAction(initAction, null);
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    return navigator.router.getStateForAction(action, state) || state;
  };
}

;
export { createNavigationReducer, initAction };